<template>
    <div id="app">
        <div class="bg"/>
        <MainComponent class="center"/>
    </div>
</template>

<script>
    import MainComponent from "./components/MainComponent";
    export default {
        name: 'App',
        components: {
            MainComponent
        }
    }
</script>

<style>
    * {
        margin: 0;
    }

    #app {
        height: 100vh;
        background-color: #0f0c12;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        overflow-x: hidden;
    }

    .bg {
        position: fixed;
        top: -50%;
        left: -50%;
        right: -50%;
        bottom: -50%;
        width: 200%;
        height: 200vh;
        background: transparent url('~@/assets/noise-transparent.png') repeat 0 0;
        animation: bg-animation .2s infinite;
        opacity: .9;
        visibility: visible;
    }

    @keyframes bg-animation {
        0% {
            transform: translate(0, 0)
        }
        10% {
            transform: translate(-5%, -5%)
        }
        20% {
            transform: translate(-10%, 5%)
        }
        30% {
            transform: translate(5%, -10%)
        }
        40% {
            transform: translate(-5%, 15%)
        }
        50% {
            transform: translate(-10%, 5%)
        }
        60% {
            transform: translate(15%, 0)
        }
        70% {
            transform: translate(0, 10%)
        }
        80% {
            transform: translate(-15%, 0)
        }
        90% {
            transform: translate(10%, 5%)
        }
        100% {
            transform: translate(5%, 0)
        }
    }

    .center {
        margin-top: -40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>
